<template>
  <template v-if="isApplicationLoading">
    <Loading />
  </template>
  <template v-else>
    <div class="my-5">
      <SectionContainer class="landlord-description">
        <h2 class="text-xl font-semibold my-3">Leasing Company</h2>
        <div
          class="flex py-3 w-1/2 md:w-10 landlord-description-item"
          v-if="getCurrentApplication.landlord.logo"
        >
          <img :src="getCurrentApplication.landlord.logo" class="w-full h-auto" />
        </div>
        <div
          class="flex py-3 landlord-description-item"
          v-if="getCurrentApplication.landlord.address"
        >
          <LocationMarkerIcon class="text-brand-blue mr-5 w-7 h-7" />
          <p class="">
            {{ getCurrentApplication.landlord.address }}
          </p>
        </div>
        <div
          class="flex py-3 landlord-description-item"
          v-if="getCurrentApplication.landlord.phone"
        >
          <PhoneIcon class="text-brand-blue mr-5 w-7 h-7" />
          <p class="font-normal">
            {{ getCurrentApplication.landlord.phone }}
          </p>
        </div>
        <div
          class="flex py-3 landlord-description-item"
          v-if="getCurrentApplication.landlord.display_email"
        >
          <MailOpenIcon class="text-brand-blue mr-5 w-7 h-7" />
          <p class="font-normal">
            {{ getCurrentApplication.landlord.display_email }}
          </p>
        </div>
        <div
          class="flex py-3 landlord-description-item"
          v-if="getCurrentApplication.landlord.company_name"
        >
          <OfficeBuildingIcon class="text-brand-blue mr-5 w-7 h-7" />
          <p class="font-normal">
            {{ getCurrentApplication.landlord.company_name }}
          </p>
        </div>

        <div
          class="flex py-3 landlord-description-item"
          v-if="getCurrentApplication.landlord.website"
        >
          <GlobeIcon class="text-brand-blue mr-5 w-7 h-7" />
          <p class="font-normal">
            {{ getCurrentApplication.landlord.website }}
          </p>
        </div>

        <Line />

        <div class="py-3 flex flex-row w-full application-fee">
          <div class="w-1/2">
            <p class="font-semibold">Reports requested:</p>
          </div>
          <div class="w-1/2 text-right">
            <p
              class=""
              v-for="report in getCurrentApplication.reports.filter(
                (r) => r.status === 'sent_payment_request'
              )"
              :key="report.id"
            >
              {{ report.short_label }}
            </p>
          </div>
        </div>

        <Line />

        <div class="py-3 flex flex-row w-full application-fee">
          <div class="flex-1">
            <p class="font-bold">Total</p>
          </div>
          <div class="flex-1 text-right">
            <p class="font-semibold">${{ totalFee }}</p>
          </div>
        </div>
      </SectionContainer>

      <div class="my-5 max-w-screen-md mx-2 md:mx-auto">
        <AlertToast>
          <div class="px-5 py-8">
            <div class="flex mb-5">
              <img src="@/assets/icons/lock-yellow.svg" class="mr-5" />
              <p>SSNs and credit cards are never visible to landlords</p>
            </div>
            <div class="flex">
              <img src="@/assets/icons/shield-yellow.svg" class="mr-5" />
              <p class="font-normal">Data is never sold to third-parites</p>
            </div>
          </div>
        </AlertToast>
      </div>

      <div class="mx-2 md:mx-auto md:w-1/3 pb-10">
        <PrimaryButton @click="navigateNext">Order Reports</PrimaryButton>
      </div>
    </div>
  </template>
</template>
<script>
import { mapGetters } from "vuex"

import {
  LocationMarkerIcon,
  PhoneIcon,
  MailOpenIcon,
  OfficeBuildingIcon,
  GlobeIcon
} from "@heroicons/vue/outline"

export default {
  components: {
    LocationMarkerIcon,
    PhoneIcon,
    MailOpenIcon,
    OfficeBuildingIcon,
    GlobeIcon
  },
  computed: {
    ...mapGetters(["getCurrentApplication", "isApplicationLoading"]),
    totalFee() {
      if (!this.getCurrentApplication) {
        return 0
      }
      return this.getCurrentApplication.reports
        .filter((r) => r.status === "sent_payment_request")
        .reduce((total, r) => {
          return total + r.price
        }, 0)
        .toFixed(2)
    }
  },
  methods: {
    navigateNext() {
      if (this.getCurrentApplication.need_applicant_finicity_bank_connection) {
        this.$router.push({ name: "request_payment_income" })
      } else {
        this.$router.push({ name: "request_payment_pay" })
      }
    }
  }
}
</script>
